<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark" style="width: 100%;">
    <div class="px-1" style="width: 100%">
      <div class="row" style="width: 100%">
        <div class="col-9">
          <router-link v-if="!isAuth" class="navbar-brand" to="/login" @click="$router.go()">JIR</router-link>
          <router-link v-else class="navbar-brand" to="/inicio" @click="$router.go()">JIR</router-link>
        </div>
        <div class="col-3" style="text-align: right;">
<!--          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"></span></button>-->
          <a v-if="isAuth" href="#" @click="cerrarSesion()"><FontAwesomeIcon :icon="faSignOut()" title="Cerrar sesión"/></a>
        </div>
      </div>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          <template v-if="!isAuth">
<!--            <li class="nav-item"><router-link class="nav-link" to="/login">Iniciar sesión</router-link></li>-->
          </template>
          <template v-else>
<!--            <li class="nav-item"><router-link class="nav-link" to="/registrarEvento" v-if="$localStorageService.can('api.REGISTRO_ASISTENCIA')">Registrar entrada/salida</router-link></li>-->
<!--            <li class="nav-item"><router-link class="nav-link" to="/registrarEvidencia" v-if="$localStorageService.can('api.REGISTRO_EVIDENCIA')">Registrar evidencia</router-link></li>-->
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" id="navbarDropdownBlog" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{nombreUsuario}}
              </a>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdownBlog">
<!--                <li><router-link class="dropdown-item" to="/historial">Historial de eventos</router-link></li>-->
<!--                <li><a class="dropdown-item" href="blog-home.html">Cambiar contraseña</a></li>-->
                <li><a class="dropdown-item" href="#" @click="cerrarSesion()">Cerrar sesión</a></li>
              </ul>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>

import {faSignOut} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
  inject: ['$localStorageService'],
  name: 'Header-Component',
  components: {
    FontAwesomeIcon

  },
  data() {
    return {
      isAuth: false
    }
  },
  computed: {
    nombreUsuario() {
      return this.$localStorageService.getNombreCompleto();
    }
  },
  watch:{
    $route (){
      this.isAuth = this.$localStorageService.isAuth();
    }
  },
  created() {
  },
  async mounted() {
  },
  methods: {
    faSignOut() {
      return faSignOut
    },
    cerrarSesion() {
      this.$localStorageService.destroy();
      this.$router.push({ name: 'login' }).then(() => {
        this.$router.go(0);
      });

    }
  },
  filters: {

  }
};
</script>

<style scoped>

</style>
